module.exports = __webpack_public_path__ + "src/assets/textures/env/hay_bale/hay_bale_1k_bake.png";